// DS: C92
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Flex from '@wix/da-ds/pkg/Flex';
import CoreBadgeList from '../coreBadge/CoreBadgeList';
import FaveStat from './FaveStat';
import CommentStat from './CommentStat';
import ViewStat from './ViewStat';
import SubscriberStat from './SubscriberStat';
var Stats = function (_a) {
    var deviation = _a.deviation, showOnlyNumbers = _a.onlyNumbers, _b = _a.withFavouriteControl, withFavouriteControl = _b === void 0 ? true : _b, _c = _a.withCommentControl, withCommentControl = _c === void 0 ? true : _c, _d = _a.withViewCount, withViewCount = _d === void 0 ? true : _d, _e = _a.withSubscriberCount, withSubscriberCount = _e === void 0 ? true : _e, _f = _a.withBadges, withBadges = _f === void 0 ? true : _f, className = _a.className, statClassName = _a.statClassName;
    var isMobile = useContext(MobileContext);
    var onlyNumbers = !!(showOnlyNumbers || isMobile);
    return (React.createElement(Flex, { className: className, justifyContent: "space-between" },
        React.createElement(Flex, { alignItems: "center" },
            withFavouriteControl && (React.createElement(FaveStat, { className: statClassName, deviation: deviation, onlyNumbers: onlyNumbers })),
            withCommentControl && (React.createElement(CommentStat, { className: statClassName, deviation: deviation, onlyNumbers: onlyNumbers })),
            withViewCount && (React.createElement(ViewStat, { className: statClassName, deviation: deviation, onlyNumbers: onlyNumbers })),
            withSubscriberCount && (React.createElement(SubscriberStat, { className: statClassName, deviation: deviation, onlyNumbers: onlyNumbers }))),
        withBadges && React.createElement(CoreBadgeList, { deviation: deviation })));
};
export default Stats;
//# sourceMappingURL=Stats.js.map